import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useEnvironment } from '../../context/EnvironmentContext';

export function FinancialGuard({ children }: { children: ReactNode }) {
  const { merchant, financialLocked } = useAuth();
  const { isSandbox } = useEnvironment();

  if (!financialLocked && merchant?.status === 'active') {
    return <>{children}</>;
  }

  if (merchant?.status === 'pending') {
    return (
      <div className="max-w-xl mx-auto text-center py-16">
        <div
          className={`inline-flex p-4 rounded-2xl mb-6 ${
            isSandbox ? 'bg-onyx-purple/10 text-onyx-purple' : 'bg-onyx-gold/10 text-onyx-gold'
          }`}
        >
          <Clock size={40} />
        </div>
        <h2 className="font-display text-3xl mb-3">Verification in progress</h2>
        <p className="text-onyx-muted leading-relaxed">
          Your account is being reviewed by our compliance officer. Financial operations are locked until
          approval. Typical review time is up to 24 hours.
        </p>
        <Link
          to="/kyb"
          className={`inline-block mt-8 text-sm font-semibold underline ${
            isSandbox ? 'text-onyx-purple' : 'text-onyx-gold'
          }`}
        >
          Complete KYB onboarding →
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto text-center py-16 text-onyx-muted">
      <h2 className="font-display text-2xl text-onyx-text mb-2">Access restricted</h2>
      <p>Account status: {merchant?.status ?? 'unknown'}. Contact support.</p>
    </div>
  );
}
